import { UntypedFormControl, ValidatorFn } from '@angular/forms';
import { AppSettings } from '../common/config';

interface ValidationResult {
  [key: string]: boolean;
}

const YOUTUBE_VIDEO_ID_PATTERN = /^[A-Za-z0-9_-]{11}$/;
const YOUTUBE_HOSTS = ['youtube.com', 'www.youtube.com'];

export function extractYoutubeVideoId(candidate: unknown): string | null {
  if (
    typeof candidate !== 'string' ||
    candidate === '' ||
    candidate.trim() !== candidate ||
    /[\u0000-\u001F\u007F]/.test(candidate) ||
    !/^https?:\/\/[^/]/.test(candidate) ||
    candidate.includes('\\')
  ) {
    return null;
  }

  let url: URL;
  try {
    url = new URL(candidate);
  } catch (_error) {
    return null;
  }

  if ((url.protocol !== 'http:' && url.protocol !== 'https:') || url.username || url.password) {
    return null;
  }

  let videoId: string | null = null;
  if (url.hostname === 'youtu.be') {
    const pathSegments = url.pathname.split('/').filter(Boolean);
    if (pathSegments.length === 1) {
      videoId = pathSegments[0];
    }
  } else if (YOUTUBE_HOSTS.includes(url.hostname)) {
    if (url.pathname === '/watch') {
      videoId = url.searchParams.get('v');
    } else {
      const pathSegments = url.pathname.split('/').filter(Boolean);
      if (pathSegments.length === 2 && ['shorts', 'embed', 'live'].includes(pathSegments[0])) {
        videoId = pathSegments[1];
      }
    }
  }

  return videoId && YOUTUBE_VIDEO_ID_PATTERN.test(videoId) ? videoId : null;
}

export class VimeoYoutubeUrlValidator {
  public static vimeoYoutubeUrlFormat(control: UntypedFormControl): ValidationResult {
    if (
      control.value &&
      !AppSettings.VIMEO_URL_REGEX_PATTERN.test(control.value) &&
      !extractYoutubeVideoId(control.value)
    ) {
      return { vimeoYoutubeUrlFormat: true };
    }
    return null;
  }

  public static forInitialValue(initialValue: unknown): ValidatorFn {
    const originalValue = initialValue;

    return (control: UntypedFormControl): ValidationResult => {
      if (
        control.value === originalValue &&
        originalValue !== undefined &&
        originalValue !== null &&
        originalValue !== ''
      ) {
        return null;
      }
      return VimeoYoutubeUrlValidator.vimeoYoutubeUrlFormat(control);
    };
  }
}
